export default __webpack_public_path__ + "static/media/2.bcd7035d.png";